export const headingTokens = {
  fonts: {
    headingFontFamily: '$primary'
  },
  fontWeights: {
    headingFontWeight: '$medium'
  }
}
